// extracted by mini-css-extract-plugin
export default {"NewAdminDialog":"NewAdminDialog_NewAdminDialog__8kZmG"};